$( document ).ready(function() {
  // ================= Slideshow =============== //
  $('.slideshow-inner').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    arrows: false
  });

  // ================= Best seller category list =============== //

  $('body').on('click', '.category-inner ul li', function(e) {
    e.preventDefault();
    var id = $(this).attr('data-id');
    $('.category-inner ul li').removeClass('active');
    $('.category-image-list-inner').removeClass('active-tab');
    $('.category-list li').removeClass('active');
    $('.category-image .single-category-image').removeClass('active');
    $('.product--list').removeClass('active-tab');
    $('.product--list .collection-list').removeClass('active-tab');
    $(this).addClass('active');
    $('.category-image-list-inner[data-id="'+id+'"]').addClass('active-tab');
    $('.category-image-list-inner[data-id="'+id+'"]').find('.category-list li:first-child').addClass('active');
    $('.category-image-list-inner[data-id="'+id+'"]').find('.category-image .single-category-image:first-child').addClass('active');
    $('.product--list[data-id="'+id+'"]').addClass('active-tab');
    $('.product--list[data-id="'+id+'"] .collection-list:first-child').addClass('active-tab');
    $('.collection-list--slider').slick('refresh');
  });

  $(".category-list li .main_list_menu").hover(function(){
    var id = $(this).parent('li').attr('data-id');
    $('.category-list li').removeClass('active');
    $('.category-image .single-category-image').removeClass('active');
    $('.product--list .collection-list').removeClass('active-tab');
    $(this).parent('li').addClass('active');
    $('.category-image .single-category-image[data-id="'+id+'"]').addClass('active');
    $('.collection-list[data-id="'+id+'"]').addClass('active-tab');
    $('.collection-list--slider').slick('refresh');
  });

  $(".list-without-content li").click(function(){
    var id = $(this).data('id');
    var parent_id = $(this).closest('.category-image-list-inner').data('id');
    $(".category-image-list-inner[data-id="+parent_id+"] .list-without-content li").removeClass('active');
    $(this).addClass('active');
    $(".category-image-list-inner[data-id="+parent_id+"] .category-image-hover .single-category-image").removeClass('active');
    $(".category-image-list-inner[data-id="+parent_id+"] .category-image-hover .single-category-image[data-id="+id+"]").addClass('active');
  });

  // ================= Collection Product slider =============== //
  $('.collection-list--slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  // ================= Image with text image slider JS =============== //
  $('.image-slider-wrapper-inner').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  // ================= Logo infinite Slick Carousel ===================== //
  $(".logo-slick-slider").slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    slidesToShow: 9,
  	slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
  	centerMode: true,
    focusOnSelect: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 7,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 480,
        settings: {
          speed: 3000,
          slidesToShow: 2,
          variableWidth: true
        }
      }
    ]
  });

  // Collection Filter
  $('body').on('click', '.coll-filter-btn', function() {
    $('.filter-drawer').toggleClass('open-drawer');
  });

  // Accordion Js
   $(".accordion-item .accordion--label").click(function(e){
    e.preventDefault();
    if ($(this).closest('.accordion-item').hasClass('active-accordion')){
      $(".accordion-item").removeClass("active-accordion");
      $(".accordion-item .accordion--content").slideUp(100);			
      $(".faqs-accordion").removeClass("sub-accordion-active");
    } else {
      $(".faqs-accordion").addClass("sub-accordion-active");
      $(".accordion-item").removeClass("active-accordion");
      $(this).closest('.accordion-item').addClass('active-accordion'); 
      $(".accordion-item .accordion--content").slideUp(100);		
      $(".accordion-item.active-accordion .accordion--content").slideToggle(100);
    }
  });

  $('.inside-backbutton').click(function(){
    $(this).closest('.faqs-accordion').removeClass('sub-accordion-active');
    $(this).siblings('.faqs-accordion .accordion-item').removeClass('active-accordion');
    $(this).siblings('.faqs-accordion .accordion-item').children('.accordion--content').hide();
  });

  $('.faqs--button').click(function(){
    $(this).closest(".shop-by-inner").addClass('faq--active');
  });$('.outside-backbutton').click(function(){
    $(this).closest(".shop-by-inner").removeClass('faq--active');
  });

  
  $('.with-inner-content li a').click(function(){
    $(this).closest(".category-list").addClass('list-inner-content');
    $(this).closest(".category--content").show();
  });

  $('.inside-backbutton').click(function(){
    $(this).closest('.category-list').removeClass('list-inner-content');
  });

  // Product media
  if($('.product-media-inner').length){
  const sliderContainer = document.querySelector('.product-media-inner');
  const images = sliderContainer.querySelectorAll('.single-image');

    if (images.length >= 2) {
      $('.product-media-inner').slick({
        dots: true,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
      });
    }
  }
  
  //-------- Popup Js
  function openPopup(a) {
    $('.popup-wrapper.'+a).addClass('show_popup');
    $('body').addClass('no-scroll');
  }

  function closePopup() {
    $('.popup-wrapper').removeClass('show_popup');
    $('body').removeClass('no-scroll');
  }
  
  $('body').on('click','.popup-btn', function(e) {
    e.preventDefault();
    var id = $(this).attr('data-popup-href');
    openPopup(id);
  });

  $('body').on('click','.popup-wrapper .close--popup', function(e) {
    e.preventDefault();
    closePopup();
  });

   window.onclick = function(e) {
      if ($(e.target).hasClass('popup-wrapper')) {
        closePopup();
      }   
    }

  $(document).keyup(function(e) {
    if (e.keyCode == 27) { 
      closePopup();
    }
  });    

  //--------------- Product page tab Js
  $(".ingredients--list-inner ul li").click(function(){
    $(".ingredients--list-inner ul li").removeClass('active');
    $(this).addClass('active');

    var id = $(this).data('id');

    $(".ingredients--content-inner").removeClass('active');
    $(".ingredients--content-inner[data-id="+id+"]").addClass('active');
  });

  //------------------ Brand Logo Hover JS 
  $(".single-partnership-detail").hover(function() {
    // Add 'hover--effect' class to siblings and remove from current element
    $(this).siblings('.single-partnership-detail').addClass('hover--effect');
    $(this).siblings('.single-partnership-detail').removeClass('active--hover');
    $(this).addClass('active--hover');
    $(this).removeClass('hover--effect');
  }, function() {
    // Remove 'hover--effect' class from all siblings
    $('.single-partnership-detail').removeClass('hover--effect');
    $('.single-partnership-detail').removeClass('active--hover');
  });

  // ------------------- Sustainability Tab list 
  $(".sustainability--list .category-list li").click(function(){
    var id = $(this).data('id');
    $(".single-category-list-content").removeClass('active');
    $(".single-category-list-content[data-id="+id+"]").addClass('active');
  });

  // ------------------- Product Sticky Bar
  $(window).scroll(function() {
    if ($('.product--main').length) {
      var Product_up = $('.product--main').offset().top;
      var product_section_height = $('.product--main').outerHeight();
      var full_scroll = Product_up + product_section_height - $('.header').outerHeight();
      if ($(this).scrollTop() > full_scroll) {
        if ($(this).scrollTop() < ($('footer').offset().top - $('.header').outerHeight() - $('.pdp-sticky-bottom').outerHeight() - 300)) {
          $('body .pdp-sticky-bottom').addClass('active');
        } else {
          $('body .pdp-sticky-bottom').removeClass('active');
        }
      } else {
        $('body .pdp-sticky-bottom').removeClass('active');
      }
    }
  });

  $('.review--content-slider').slick({
    dots: false,
    infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  window.addEventListener('load', function() {
    const bundlesHolder = document.querySelector('#bogos-bundle-view');
    const selector = window.bundleOfferId ? `.bogos-bundles-widget[data-bundle-id="${window.bundleOfferId}"]` : '.bogos-bundles-widget';

    if (bundlesHolder) {
      const interval = setInterval(() => {
        const visibleOffer = bundlesHolder.querySelector(selector)
        
        if (visibleOffer) {
          clearInterval(interval);
          visibleOffer.querySelector('.bogos-bundles-widget-title').textContent = window.bundleSectionTitle;
          visibleOffer.classList.add('is-visible');
        }
      }, 200);
    }
  })
});
